<template>
  <div>
    <TopBar title="Scanner" :cart="false"/>
    <div class="page-content">
      <div class="container">
        <div v-if="loading" class="dz-spinner color-spinner">
          <div class="spinner-border spinner-sm me-2 mb-2 text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

        <div v-if="table_id">
          <div class="box">
            <img src="../../../assets/Changementdetable.png" alt="">
            <br> <br>
            <div class="text-center mt-3">
              <h5 class="text-primary">Table A59</h5>
              <p class="text-dark mb-0">Changer de table</p>
              <p class="text-dark mb-0">En un clic si besoin</p>
              <br><br>
            </div>
          </div>
        </div>

        <Scanner v-if="!table_id && allow" v-model="table_id"/>

        <div v-if="!table_id && !allow">
          <div class="box">
            <img src="../../../assets/Prendreunetable.png" alt="">
            <br> <br>
            <div class="text-center mt-3">
              <h5 class="text-danger">Oups !</h5>
              <p class="text-dark mb-0">Nous n'avons pu identifier votre table. </p>
              <p class="text-dark mb-0">Veuillez scanner la table</p>
              <br>
            </div>
          </div>
        </div>

        <div class="footer fixed">
          <div class="footer-wrapper container">
            <button v-if="table_id" @click.prevent="resetTable" class="btn mt-2 btn-primary w-100 btn-rounded" :disabled="loading">
              Changer de table
            </button>

            <button v-if="!table_id && allow"  @click.prevent="deniedScanning" class="btn mt-2 btn-primary w-100 btn-rounded" :disabled="loading">
             Annuler
            </button>

            <button v-if="!table_id && !allow"  @click.prevent="resetTable" class="btn mt-2 btn-primary w-100 btn-rounded" :disabled="loading">
              Scanner une table
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, watch} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import Scanner from "@/components/scanner";

const store = useStore()
const loading = ref(false)
const table_id = ref('')
const calling = ref(false)
const allow = ref(false)
const router = useRouter();

onMounted(() => {
  table_id.value = table.value
})

const table = computed(() => store.getters['contact/table'])

watch(() => table.value, () => {
  if(!table.value){
    //onInit()
    table_id.value = table.value
  }
})

watch(() => table_id.value, () => {
  if(table_id.value && table.value != table_id.value){
    setTable()
  }
})

function resetTable() {
  table_id.value = ""
  allow.value = true
}

function deniedScanning(){
  allow.value = false
}


function setTable () {
  store.dispatch('contact/loadTable', table_id.value)
  // router.push({name:'home-page'})
}

</script>
<style scoped>




</style>